import React from 'react';

import analyticService from '../../../services/analytics';
import linkoutIcon from '../../../images/icons/linkout.svg';
import { formatNumber } from '../../base/common/utils';
import Tooltip from '../../misc/tooltip';

const SearchStats = ({ searches }) => {
  const getChangeType = search => {
    if (search.previous_count === 0) return 'new';
    return search.percent_change >= 0 ? 'positive' : 'negative';
  };

  const formatSearchChange = search => {
    let percentChange = search.percent_change;
    if (search.previous_count === 0) {
      return 'New';
    }
    percentChange =
      percentChange > -1 && percentChange < 1 && percentChange !== 0
        ? parseFloat(percentChange).toFixed(2)
        : `${Math.round(percentChange)}`;
    return percentChange > 1000 ? '1000%+' : `${Math.abs(percentChange)}%`;
  };

  const onLinkoutClick = pageUrl => {
    analyticService.trackEvent('Search Trends', 'Click', `Hyperlink [${pageUrl}]`);
  };

  const addTooltip = (el, label) => {
    const tooltipData = { text: label, size: 0.6 };
    const maxWidth = 300;
    if (el && el.offsetWidth >= maxWidth) {
      new Tooltip(el, tooltipData);
    }
  };

  const trends = searches.map((statObject, i) => {
    const linkout = statObject.page_url ? (
      <a
        className="page-url"
        rel="noopener noreferrer"
        href={statObject.page_url}
        target="_blank"
        onClick={() => onLinkoutClick(statObject.page_url)}
      >
        <img src={linkoutIcon} alt="Open search" />
      </a>
    ) : null;

    return (
      <div className="searches-row" key={i}>
        <div ref={node => addTooltip(node, statObject.search_phrase)} className="search-phrase">
          {statObject.search_phrase}
        </div>
        {linkout}
        <div className="search-summary">
          <div className="percent-change">
            <div className={`change-icon ${getChangeType(statObject)}`}></div>
            <div className={`change-value ${getChangeType(statObject)}`}>
              {formatSearchChange(statObject)}
            </div>
          </div>
          <div className="current-count">{formatNumber(statObject.current_count)}</div>
        </div>
      </div>
    );
  });
  return trends;
};

export default SearchStats;
